import { render, staticRenderFns } from "./TableHeaderWithTooltip.vue?vue&type=template&id=f54db2c6&"
import script from "./TableHeaderWithTooltip.vue?vue&type=script&lang=js&"
export * from "./TableHeaderWithTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports